import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/artikel/oopbuy-spreadsheet-guide/page";
import ArticleSicherheit from "@/pages/artikel/oopbuy-sicherheitsguide/page";
import ArticleVersand from "@/pages/artikel/oopbuy-versandguide/page";
import ArticleAnfaenger from "@/pages/artikel/oopbuy-anfaenger-guide/page";
import ArticleKategorien from "@/pages/artikel/oopbuy-kategorien-uebersicht/page";
import ArticlePreisvergleich from "@/pages/artikel/oopbuy-preisvergleich/page";
import ArticleErfahrungen from "@/pages/artikel/oopbuy-erfahrungen/page";
import ArticleAlternativen from "@/pages/artikel/oopbuy-alternativen/page";
import ArticleTipps from "@/pages/artikel/oopbuy-einkaufstipps/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/artikel/oopbuy-sicherheitsguide",
    element: <ArticleSicherheit />,
  },
  {
    path: "/artikel/oopbuy-versandguide",
    element: <ArticleVersand />,
  },
  {
    path: "/artikel/oopbuy-anfaenger-guide",
    element: <ArticleAnfaenger />,
  },
  {
    path: "/artikel/oopbuy-kategorien-uebersicht",
    element: <ArticleKategorien />,
  },
  {
    path: "/artikel/oopbuy-preisvergleich",
    element: <ArticlePreisvergleich />,
  },
  {
    path: "/artikel/oopbuy-erfahrungen",
    element: <ArticleErfahrungen />,
  },
  {
    path: "/artikel/oopbuy-alternativen",
    element: <ArticleAlternativen />,
  },
  {
    path: "/artikel/oopbuy-einkaufstipps",
    element: <ArticleTipps />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;